module.exports = __webpack_public_path__ + "static/media/chat-component-icon.a92c8b7c.svg";